// @flow
import { selectTaxesDisplaySetting } from '@gandi/authentication';

import { useAppSelector } from 'src/hooks/useAppSelector';

import type { SimplehostingPriceSummary } from './modules/simplehosting/prices';
import type { ServicePrice } from './types/price';

// For the prices,
// return the price before or after taxes in function of choice of the user.

export function useGetPrice(): (price: ServicePrice) => number {
  const taxesIncluded = useAppSelector(selectTaxesDisplaySetting);

  return (price: ServicePrice) =>
    price[taxesIncluded ? 'price_after_taxes' : 'price_before_taxes'];
}

const GWH68_DISCOUNT_RATIO = 0.6808;
// Quickly format the new hosting creation discount for now - GWH68
export function formatPriceWithDiscount(
  priceInfo: SimplehostingPriceSummary,
  appliedDiscount: boolean,
  displayTaxes: boolean,
): number {
  const price = displayTaxes
    ? priceInfo.price_after_taxes
    : priceInfo.price_before_taxes;

  return appliedDiscount ? price - price * GWH68_DISCOUNT_RATIO : price;
}
